import { fromJS } from 'immutable';
import { combineReducerArray } from 'reducers/utils/helpers';
import { generateReducer } from 'reducers/utils/HttpReducerHelper';
import { coursesRequest, LRS_HEALTH_CHECK_SUCCESS, LRS_HEALTH_CHECK_FAILURE } from './types';

import playbookContentReducer from './playbook/reducer';
import Course from '../../models/CourseModel';

const initialState = fromJS({
  byId: {},
  courses: {
    ids: [],
    network: { loading: false, error: false },
  },
  lrsHealthCheck: true,
  shareCopyLink: {
    network: { loading: false, error: false },
    url: null,
  },
});

const coursesRequestReducer = generateReducer('courses', Course.deserialize);

const coursesReducer = {
  [coursesRequest.request]: coursesRequestReducer.request,
  [coursesRequest.success]: coursesRequestReducer.success,
  [coursesRequest.failure]: coursesRequestReducer.failure,
  [LRS_HEALTH_CHECK_SUCCESS]: (state) => state.set('lrsHealthCheck', true),
  [LRS_HEALTH_CHECK_FAILURE]: (state) => state.set('lrsHealthCheck', false),
};

export * from './actions';

export default combineReducerArray(initialState, [coursesReducer, playbookContentReducer]);
